// Generated by scripts/thames.ts from OpenStreetMap (ODbL). Don't edit by hand.

// The middle of the river as [longitude, latitude], flowing downstream.
const THAMES: readonly (readonly [number, number])[] = [
  [-0.085187, 51.507691],
  [-0.083935, 51.507479],
  [-0.081397, 51.507108],
  [-0.080209, 51.506871],
  [-0.075082, 51.505424],
  [-0.074133, 51.505221],
  [-0.073334, 51.504998],
  [-0.071925, 51.504456],
  [-0.070718, 51.503882],
  [-0.069111, 51.503376],
  [-0.065794, 51.502454],
  [-0.064355, 51.502184],
  [-0.062732, 51.501928],
  [-0.060867, 51.501711],
  [-0.060205, 51.50167],
  [-0.059794, 51.501678],
  [-0.059167, 51.501738],
  [-0.057848, 51.501954],
  [-0.05598, 51.502391],
  [-0.054873, 51.502795],
  [-0.048147, 51.506583],
  [-0.045495, 51.507934],
  [-0.043931, 51.508371],
  [-0.043349, 51.50848],
  [-0.042104, 51.508589],
  [-0.04093, 51.508635],
  [-0.039618, 51.508625],
  [-0.038235, 51.508494],
  [-0.036087, 51.508077],
  [-0.034175, 51.507588],
  [-0.032395, 51.506914],
  [-0.031498, 51.506436],
  [-0.030364, 51.505418],
  [-0.029662, 51.50406],
  [-0.029373, 51.50269],
  [-0.029696, 51.500144],
  [-0.029853, 51.499544],
  [-0.030023, 51.498408],
  [-0.030042, 51.497548],
  [-0.030204, 51.496067],
  [-0.030142, 51.494671],
  [-0.029815, 51.493031],
  [-0.029007, 51.491626],
  [-0.027846, 51.490055],
  [-0.027285, 51.489434],
  [-0.026599, 51.488853],
  [-0.024693, 51.487484],
  [-0.023436, 51.486802],
  [-0.021081, 51.485775],
  [-0.02002, 51.485388],
  [-0.019473, 51.485223],
  [-0.018165, 51.484876],
  [-0.01765, 51.484773],
  [-0.016043, 51.484616],
  [-0.014466, 51.484541],
  [-0.013368, 51.484524],
  [-0.012473, 51.484555],
  [-0.011428, 51.484633],
  [-0.010597, 51.484742],
  [-0.008261, 51.485158],
  [-0.006919, 51.485461],
  [-0.005753, 51.485809],
  [-0.004774, 51.486188],
  [-0.003895, 51.486607],
  [-0.002943, 51.487176],
  [-0.002185, 51.487683],
  [-0.001746, 51.488015],
  [-0.001476, 51.488307],
  [-0.000785, 51.48932],
  [-0.000581, 51.489843],
  [-0.000476, 51.490306],
  [-0.000449, 51.490913],
  [-0.000581, 51.491916],
  [-0.000833, 51.492657],
  [-0.001289, 51.493474],
  [-0.00288, 51.495638],
  [-0.003603, 51.4967],
  [-0.004525, 51.498338],
  [-0.004901, 51.499184],
  [-0.005086, 51.500121],
  [-0.005037, 51.501464],
  [-0.00469, 51.502534],
  [-0.00451, 51.502941],
  [-0.004326, 51.503238],
  [-0.004052, 51.503631],
  [-0.003673, 51.504064],
  [-0.002769, 51.504937],
  [-0.001829, 51.505606],
  [-0.001318, 51.505869],
  [-0.000919, 51.506059],
  [-0.000309, 51.506275],
  [0.000481, 51.506498],
  [0.001572, 51.506676],
  [0.002698, 51.506771],
  [0.00361, 51.506768],
  [0.004179, 51.506698],
  [0.005174, 51.506428],
  [0.005965, 51.506162],
  [0.007598, 51.50551],
  [0.008197, 51.505231],
  [0.008823, 51.504864],
  [0.009924, 51.504078],
  [0.012419, 51.50187],
  [0.015605, 51.499189],
  [0.016216, 51.498806],
  [0.017547, 51.498083],
  [0.018406, 51.497669],
  [0.01919, 51.497356],
  [0.019803, 51.497155],
  [0.021918, 51.496522],
  [0.024012, 51.496149],
  [0.024692, 51.496075],
  [0.026856, 51.496004],
  [0.027771, 51.496017],
  [0.029048, 51.496087],
  [0.030939, 51.496277],
  [0.031435, 51.496374],
  [0.032371, 51.496463],
  [0.033788, 51.496682],
  [0.034941, 51.496818],
  [0.035518, 51.496841],
  [0.036418, 51.49683],
  [0.037101, 51.496873],
  [0.038513, 51.496996],
  [0.039195, 51.497121],
  [0.040146, 51.497203],
  [0.044189, 51.497373],
  [0.045844, 51.497323],
];

export { THAMES };
